import PropTypes from 'prop-types';

/* PROPSHAPES FOR ERRORS */

const inlineErrorsPropShape = PropTypes.arrayOf(PropTypes.oneOfType([
  PropTypes.string,
  PropTypes.objectOf(PropTypes.oneOfType([PropTypes.bool, PropTypes.string])), // field error component props
]));
const modalErrorsPropShape = PropTypes.arrayOf(PropTypes.string);

const errorsPropShape = PropTypes.shape({
  inlineErrors: inlineErrorsPropShape,
  modalErrors: modalErrorsPropShape,
});

const vFParamsPropShape = PropTypes.shape({
  multiSelect: PropTypes.bool,
  fieldTitle: PropTypes.string,
  fieldSubTitle: PropTypes.string,
  displayType: PropTypes.string,
});


/* PROPSHAPES FOR V-F COMPONENTS */

// Likely to be DEPRECATED delete when/if v-f-tile-selector.DEPRECATED.jsx gets deleted
// const vFTileSelectorOptionShape = PropTypes.shape({
//   text: PropTypes.string,
//   id: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
// });
const vFSingleRadioDisplayOptionsShape = PropTypes.shape({
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.elementType]),
  text: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
});

const vFButtonSelectorOptionShape = PropTypes.shape({
  text: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
});

const dropDownOptionsShape = PropTypes.shape({
  text: PropTypes.text,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
});

const disabledFieldOptionsShape = PropTypes.shape({
  disabled: PropTypes.bool,
  disabledValue: PropTypes.any, // any as this is form data
  unDisabledValue: PropTypes.any, // any as this is form data
});

/* PROPSHAPES FOR SUMMARY-V-F COMPONENTS */

const universalSummaryVFProptypes = {
  fieldTitle: PropTypes.string,
  fieldSubTitle: PropTypes.string,
  sectionType: PropTypes.string,
  hideFromSummary: PropTypes.bool,
};

const summaryVFButtonSelectorFieldData = PropTypes.shape({
  ...universalSummaryVFProptypes,
  displayValues: PropTypes.arrayOf(vFButtonSelectorOptionShape),
  value: PropTypes.array,
});

const summaryVFDropdownFieldData = PropTypes.shape({
  ...universalSummaryVFProptypes,
  displayValues: PropTypes.arrayOf(dropDownOptionsShape),
  value: PropTypes.string,
});

const summaryVFMultiSelectFieldData = PropTypes.shape({
  ...universalSummaryVFProptypes,
  displayValues: PropTypes.arrayOf(PropTypes.string),
  value: PropTypes.arrayOf(PropTypes.any),
});

const summarySummaryVFInputFieldData = PropTypes.shape({
  ...universalSummaryVFProptypes,
  value: PropTypes.string,
});
const summarySummaryVFSingleRadioData = PropTypes.shape({
  ...universalSummaryVFProptypes,
  value: PropTypes.string,
});

const summarySummaryVFTextareaFieldData = PropTypes.shape({
  ...universalSummaryVFProptypes,
  value: PropTypes.string,
});

const summarySummaryVFDatePickerFieldData = PropTypes.shape({
  ...universalSummaryVFProptypes,
  value: PropTypes.string,
});

const summarySummaryVFModalFieldData = PropTypes.shape({
  ...universalSummaryVFProptypes,
  value: PropTypes.any,
});


/* PROPSHAPES FOR FORM SECTIONS */

const formSectionShape = PropTypes.shape({
  sectionTitle: PropTypes.string,
  fieldIdsByDisplayOrder: PropTypes.arrayOf(PropTypes.string),
  // This object has dynamic keys so...
  dataByFieldId: PropTypes.object,
});

const vFParamsShape = PropTypes.shape({
  fieldTitle: PropTypes.string,
  fieldSubTitle: PropTypes.string,
  multiSelect: PropTypes.bool,
});

const componentDataShape = PropTypes.shape({
  fieldType: PropTypes.string,
  displayOptions: PropTypes.arrayOf(PropTypes.oneOfType([
    vFButtonSelectorOptionShape,
    dropDownOptionsShape,
  ])),
  id: PropTypes.string.isRequired,
  initialValues: PropTypes.any, // any as this is form data
  vFParams: vFParamsShape,
  validator: PropTypes.func,
});

/* Proptypes for formData */

const formDataShape = PropTypes.shape({
  formSections: PropTypes.arrayOf(formSectionShape),
  riskValue: PropTypes.string,
});

// slight variation on formData
const formDataFromServerShape = PropTypes.shape({
  formSectionsByDisplayOrder: PropTypes.array,
  dataByFormSectionId: PropTypes.object,
  status: PropTypes.string,
  coordinatorName: PropTypes.string,
  peerReviewerName: PropTypes.string,
  requesterName: PropTypes.string,
  approversHistory: PropTypes.arrayOf(PropTypes.object),
});

/* misc proptypes */

const modalDisplayDataShape = PropTypes.shape({
  sectionId: PropTypes.string,
  type: PropTypes.string,
});



export {
  inlineErrorsPropShape,
  errorsPropShape,
  vFParamsPropShape,
  // vFTileSelectorOptionShape,
  vFSingleRadioDisplayOptionsShape,
  vFButtonSelectorOptionShape,
  dropDownOptionsShape,
  formSectionShape,
  componentDataShape,
  summaryVFButtonSelectorFieldData,
  summarySummaryVFInputFieldData,
  summarySummaryVFSingleRadioData,
  summarySummaryVFTextareaFieldData,
  summarySummaryVFModalFieldData,
  summaryVFDropdownFieldData,
  summaryVFMultiSelectFieldData,
  summarySummaryVFDatePickerFieldData,
  disabledFieldOptionsShape,
  formDataShape,
  formDataFromServerShape,
  modalDisplayDataShape,
};
